import axios from '@/api/config';

const generalSetting = {
  addGeneralSetting(data) {
    return axios.post(`${process.env.BASE_URL}/generalSetting/addGeneralSetting`, data);
  },
  updateGeneralSetting(data) {
    return axios.put(`${process.env.BASE_URL}/generalSetting/updateGeneralSetting`, data);
  },
  getGeneralSetting(data) {
    return axios.get(`${process.env.BASE_URL}/generalSetting/getGeneralSetting`, {params:data});
  },
}

export default generalSetting;



// WEBPACK FOOTER //
// ./src/api/generalSetting.js